import { render, staticRenderFns } from "./EditShippingTable.vue?vue&type=template&id=86e9c558&scoped=true"
import script from "./EditShippingTable.vue?vue&type=script&lang=js"
export * from "./EditShippingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e9c558",
  null
  
)

export default component.exports